import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {AngularFireDatabase} from '@angular/fire/compat/database';
import {FirebaseAbstractService} from '@q9elements/ui-kit/refmodels';

@Injectable()
export class FirebaseService implements FirebaseAbstractService {
  constructor(
    private afAuth: AngularFireAuth,
    private fb: AngularFireDatabase
  ) {}

  authenticate(token) {
    return this.afAuth.signInWithCustomToken(token);
  }

  getReference(path) {
    return this.fb.database.ref(path);
  }

  onChildRemove(path: string) {
    return this.fb.list(path).stateChanges(['child_removed']);
  }
}
